import React from 'react';
import '../../../assets/css/style.css';
import '../../../assets/css/bootstrap.css';

const FirstInfo = () => {
    return (
        <div className="container">
            <div className="row-1">
                <img src="img/logo-mark.png" alt="Universe" width="50px" height="auto"/>
                <h3>Welcome to Univrs</h3>
                <h5>Where finding college romance is a step easier</h5>
            </div>

            <div className="row-2">
                <h2>We have eliminated the swipe feature!</h2>
            </div>

            <div className="row-3">
                <div className="intro-wrapper">
                    <p className="intro-body">
                        You will only get ten profile presented to you daily, with the option to only choose five matches. Make genuine choices, for a genuine connection. 
                    </p>
                </div>

                <button type="submit" className="uni-btn">Got It!</button>
            </div>

            <div className="row-4">

                <button className="nav-button">
                    <i className="btn-icon fa fa-address-book" aria-hidden="true"></i>
                    <span className="btn-txt">Name</span>
                </button>

                <button className="nav-button">
                    <i className="btn-icon fa fa-birthday-cake" aria-hidden="true"></i>
                    <span className="btn-txt">Age</span>
                </button>

                <button className="nav-button">
                    <i className="btn-icon fa fa-venus-mars" aria-hidden="true"></i>
                    <span className="btn-txt">Gender</span>
                </button>

                <button className="nav-button" active>
                    <i className="btn-icon fa fa-university" aria-hidden="true"></i>
                    <span className="btn-txt">Campus</span>
                </button>

                <button className="nav-button">
                    <i className="btn-icon fa fa-picture-o" aria-hidden="true"></i>
                    <span className="btn-txt">Pictures</span>
                </button>

                <button className="nav-button">
                    <i className="btn-icon fa fa-heart" aria-hidden="true"></i>
                    <span className="btn-txt">Interests</span>
                </button>

            </div>

        </div>
    );
}

export default FirstInfo;